// Static lookups for the running/cardio views. These used to be redefined
// inside ClientDashboard on every render and then threaded down as props;
// they are constants, so they live here and are imported where needed.

export const intervalTypeNames = {
  warmup: "Rozgrzewka",
  run: "Bieg",
  recovery: "Odpoczynek",
  sprint: "Sprint",
  cooldown: "Schładzanie",
  walk: "Marsz",
};

export const difficultyLabels = {
  easy: "Łatwy",
  medium: "Średni",
  hard: "Trudny",
  expert: "Ekspert",
};

// Katalog aktywności przychodzi z backendu (`GET /api/activity-types`) — tam jest
// jedno źródło prawdy. Poniższe wartości to tylko awaryjny komplet na pierwsze
// malowanie i na wypadek, gdyby żądanie padło; setActivityCatalogue podmienia je
// na to, co naprawdę obsługuje serwer. Wcześniej ta lista była kopią, która po
// cichu rozjeżdżała się z backendem: nie było w niej ani roweru, ani pływania.
export const activityTypeLabels = {
  running: "Bieg",
  treadmill: "Bieżnia",
  ergometer: "Ergometr",
  nordic_walking: "Nordic walking",
};

// Aktywności zapisujące ślad GPS; resztę loguje się ręcznie.
export const gpsActivityTypes = ["running", "nordic_walking"];

// Czym mierzy się wynik: "pace" (min/km), "speed" (km/h), "pace_100m" (min/100 m).
export const activityMetrics = {};

// Kolejność do list wyboru — taka, jaką zwrócił serwer.
export const activityOrder = [];

export function setActivityCatalogue(list) {
  if (!Array.isArray(list) || list.length === 0) return;
  for (const key of Object.keys(activityTypeLabels)) delete activityTypeLabels[key];
  gpsActivityTypes.length = 0;
  activityOrder.length = 0;
  for (const a of list) {
    activityTypeLabels[a.key] = a.label;
    activityMetrics[a.key] = a.metric;
    activityOrder.push(a.key);
    if (a.gps) gpsActivityTypes.push(a.key);
  }
}

/** Wynik w jednostce właściwej dla aktywności.
 *
 * Rowerzyście pokazanie „4,0 min/km" jest formalnie poprawne i nikt tego tak nie
 * czyta — dlatego jednostka idzie z katalogu, a nie z założenia, że wszystko jest
 * bieganiem. */
export function formatEffort(activityType, distanceKm, durationSeconds) {
  const metric = activityMetrics[activityType] || "pace";
  const km = Number(distanceKm) || 0;
  const sec = Number(durationSeconds) || 0;
  if (km <= 0 || sec <= 0) return { value: "--", unit: metric === "speed" ? "km/h" : metric === "pace_100m" ? "min/100m" : "min/km" };
  if (metric === "speed") return { value: (km / (sec / 3600)).toFixed(1), unit: "km/h" };
  if (metric === "pace_100m") return { value: ((sec / 60) / (km * 10)).toFixed(2), unit: "min/100m" };
  return { value: ((sec / 60) / km).toFixed(1), unit: "min/km" };
}

export const formatRunTime = (s) =>
  `${Math.floor(s / 60)}:${(s % 60).toString().padStart(2, "0")}`;
